import {
  Measure
} from '../common/measure';

export class TreeService {
  constructor() {
    this.oneRow = 15;
  }

  getRoot(model, aggregate) {
    const rows = aggregate.cells.map((cell, c) => {
      cell.rowIndex = c;
      return aggregate.filter.drilldown.map((dd, d) => {
        const measureLabel = Measure.getMeasure(cell, aggregate.filter.measure);
        let field = model.getCellLabel(
          dd,
          cell,
        );
        if (cell.record_count && aggregate.filter.drilldown[aggregate.filter.drilldown.length - 1] === dd) {
          field = `${field} (${measureLabel})`;
        }
        return {
          name: field,
          dd: dd,
          cell: cell
        };
      });
    });

    // console.log("ROWS", rows);

    const children = aggregate.cells.map((cell) => {
      return {
        'name': model.getCellLabel(
          aggregate.filter.drilldown[0],
          cell,
        ),
      };
    });

    const root = {
      'name': gettext('Все события'),
      'children': []
    };

    const updateTree = (node, row) => {
      if (!row[0]) return;
      let child = node.children.find((child) => child.name === row[0].name);
      if (!child) {
        child = {
          'name': row[0].name,
          'dd': row[0].dd,
          'cell': row[0].cell,
          'children': []
        };
        node.children.push(child);
      }
      updateTree(child, row.splice(1));
    };

    rows.forEach((row) => updateTree(root, row));

    //console.log("ROOT", root);

    function collapse(d) {
      if (d.children) {
        d._children = d.children;
        d._children.forEach(collapse);
        d.children = null;
      }
    }

    //root.children.forEach(collapse);
    return root;
  }

  getRowsQuantity(root) {
    let calc = 0;
    const iter = el => {
      if (!el.children || !el.children.length) {
        calc += 1;
        return;
      }
      el.children.map(ch => {
        iter(ch);
      });
    };
    iter(root);
    return calc;
  }

  getHeight(model, data) {
    return this.getRowsQuantity(this.getRoot(model, data)) * this.oneRow;
  }
}



// WEBPACK FOOTER //
// ./src/stat/tree.service.js